module.exports = __webpack_public_path__ + "static/img/p22@2x.e03dfbd3.png";